import React from 'react'
import { Container, Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const GridSpinner = ({ width, color, ...rest }) => {
  return (
    <Container
      display={'flex'}
      {...rest}
      key="grid-spinner-key"
      flexDirection="row"
      flexJustify="center"
      flexAlign="center"
    >
      <Container display={'flex'} textAlign="center">
        <Spinner width={width} color={color} />
      </Container>
    </Container>
  )
}

GridSpinner.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string,
}

export default GridSpinner
